import Button from "../../base/Button";

const renderIcon = (color) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="22"
        viewBox="0 0 24 22"
    >
        <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="square">
            <path d="M1.25 5V1h4M19.25 1h4v4M10.25 1h4M1.25 17v4h4M19.25 21h4v-4M10.25 21h4M1.25 10v2M23.25 10v2" />
        </g>
    </svg>
);

/**
 * Toolbar button for rectangle selection mode.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered rectangle button.
 */
const RectangleButton = (props) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default RectangleButton;
